import React from 'react';
import AppBaseComponent from '../../../../components/AppBaseComponent';
import {connect} from "react-redux";
import tapIcon from "../../../../services/TapIcon";
import Ax from '../../../../components/hoc/Ax';
import HttpAPICall from '../../../../services/HttpAPICall';
import TapApiUrls, { INVENTORY_API_BASE_URL_2 } from '../../../../services/TapApiUrls';
import Loader from '../../../../components/ui/Loader/Loader';
import { Modal } from 'bootstrap';
import { toast } from 'react-toastify';
import swal from "sweetalert";
import { Link } from 'react-router-dom';
import Status from '../../../../components/ui/Status';


class GeneralSettings extends AppBaseComponent {

    constructor(props) {
        super(props);

        this.initAddTermForm        =       {
            name                    :       '',
        }

        this.state                  =        {
           listing_loading          :        false,
           termsListing             :        [],
           addTermFormSubmitting   :        false,
           addTermForm              :        {...this.initAddTermForm},
           edit                     :        false,
        }

        this.dealTypeListUrl    =   INVENTORY_API_BASE_URL_2  + "/deal_type/list";  
        this.dealTypeEditUrl    =   INVENTORY_API_BASE_URL_2  + "/deal_type/update"; 
        this.dealTypeAddUrl    =   INVENTORY_API_BASE_URL_2  + "/deal_type/add"; 
        this.dealTypeStatusUrl   =   INVENTORY_API_BASE_URL_2  + "/deal_type/change_status";                
    }

    componentDidMount(){
        this.addTermsModal            =        new Modal(document.getElementById('addTermsModal'), {keyboard: false, backdrop :false});
        this.getTermsListing()
    }
    
    getTermsListing         =       ()          =>      {
        this.setState({ listing_loading : true});
        HttpAPICall.withAthorization('GET', this.dealTypeListUrl, this.props.access_token,{},{},(response) => {
            this.setState({termsListing : response.data.data})
         }).then(() => this.setState({listing_loading : false}));
    }

    addTermsModalInit     =       ()      =>      {
       
        this.setState({edit : false},() =>  this.addTermsModal.show() )
    }

    editTermForm            =       (id)      =>      {

        let termList         =       this.state.termsListing.find(function (term) {
            return term.id == id;
        });

        this.setState({
            addTermForm      :              {
                id           :          termList.id,
                name         :          termList.name,
            },edit           :          true
        },() => this.addTermsModal.show())
     
  
    }

    submitAddTermForm    =          (e)      =>      {
        e.preventDefault()
        let frmData = {...this.state.addTermForm}

        this.setState({addTermFormSubmitting: true})
           
        if(this.state.edit){
            HttpAPICall.withAthorization('PUT', this.dealTypeEditUrl, this.props.access_token, {} , {...frmData,} , (response) => {
                toast.success(response.data.msg, {position: toast.POSITION.TOP_RIGHT});
                this.addTermsModal.hide();
                this.getTermsListing()
                this.setState({addTermForm  :  {...this.initAddTermForm},edit : false})
            }).then(() => this.setState({addTermFormSubmitting: false}))
        }else{
            HttpAPICall.withAthorization('POST', this.dealTypeAddUrl, this.props.access_token, {} , {...frmData,} , (response) => {
                toast.success(response.data.msg, {position: toast.POSITION.TOP_RIGHT});
                this.addTermsModal.hide();
                this.getTermsListing()
                this.setState({addTermForm  :  {...this.initAddTermForm}})
            }).then(() => this.setState({addTermFormSubmitting: false}))
        }
     }

     
     changeStatus                =    (id,status)  =>     {
        
        swal({
            title: "Change Status",
            text: "Are you sure you want to proceed?",
            icon: "warning",
            // dangerMode: true,
            buttons: ["No", "Yes"],
        })
            .then(willChangeStatus => {
                if (willChangeStatus) {
                    HttpAPICall.withAthorization('PUT', this.dealTypeStatusUrl, this.props.access_token, {},{status : status == 1 ? 2 : 1,id:id} ,(response) => {
                        toast.success(response.data.msg, {position: toast.POSITION.TOP_RIGHT});
                        this.getTermsListing();
                    }).then(() => {

                    });
                }
            });
    }

    //*********************************EDIT SETTING JSX*************************
    addTermsModalJsx              =   ()  =>  {

        return (
            <div className="modal fade" id="addTermsModal" tabIndex="-1">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="addTermsModalLabel">Deals Type</h5>
                        </div>
                        <form onSubmit={this.submitAddTermForm} id="addTermsForm" method="post" encType="multipart/form-data">
                            <div className="modal-body">
                                <div className="row align-items-center my-3">
                                    <div className="col-sm-3">
                                        <label htmlFor="transaction Type" className="form-label ">Deal Type Name</label>
                                    </div>
                                    <div className="col-sm-9">
                                        <input
                                            name="name"
                                            type="text"
                                            className="form-control"
                                            autoComplete="off"
                                            onChange={(e) => { this.formInputHandler(e, 'addTermForm') }}
                                            value={this.state.addTermForm.name}
                                            placeholder="Please Enter Deal Type Name"
                                        />
                                    </div>
                                </div>

                                
                            </div>
                            <div className="modal-footer">
                                <button type="button" disabled={this.state.addTermFormSubmitting} className="btn btn-secondary mx-2" data-bs-dismiss="modal" onClick={() => { this.setState({ addTermForm: { ...this.initAddTermForm } }) }}>Close</button>
                                <button type="submit" disabled={this.state.addTermFormSubmitting} className="btn btn-primary">
                                    Submit {this.state.addTermFormSubmitting ? (<tapIcon.FontAwesomeIcon icon={tapIcon.faSyncAlt} className="fa-spin" />) : ''}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        );
    }


    render() {
        return (
            <Ax>
                <div className="tab_content_wrapper">
                    <span className="content_heading">Deal Type</span>
                    <div className="float-end"><button className="btn btn-primary" disabled={!this.props.permissions.includes('deal_manage_deal_types')} onClick={this.addTermsModalInit} >Add </button></div>
                </div>
                <table className="table table-hover table-bordered my-3 ">
                    <thead className='table-secondary'>
                        <tr>
                            <th scope="col" style={{ width: "5%" }} className='text-center'>Sr.No</th>
                            <th scope="col">Name</th>
                            <th scope="col" style={{ width: "15%" }}>Status</th>
                            <th scope="col" className="text-center" style={{ width: "10%" }}>Action</th>
                        </tr>
                    </thead>
                    <tbody className="table-body">
                        {this.state.listing_loading
                            ? <tr>
                                <td className="text-center" colSpan="4"><Loader /></td>
                            </tr>
                            :
                            (this.state.termsListing && this.state.termsListing.length > 0
                                ? this.state.termsListing.map((term, index) => {
                                    return (<tr key={term.id}>
                                        <td className='text-center'>{index + 1}</td>
                                        <td>{term.name}</td>
                                        <td>{term.status && <Status color={term.status.status_color_code}>{term.status.status_text}</Status>}</td>
                                        <td className="ml-2 text-center">
                                            <tapIcon.imageIcon icon={tapIcon.ListActionIcon} alt="action-icon" className="img-fluid pr10 pl10"
                                                data-bs-toggle="dropdown" href="#" role="button" aria-expanded="false"
                                            />
                                            <ul className="dropdown-menu">
                                                <li>
                                                    <Link role="button"
                                                        onClick={() => {
                                                            if (this.props?.permissions?.includes('deal_manage_deal_types')) {
                                                                return this.editTermForm(term.id)
                                                            }
                                                        }}
                                                        className={['dropdown-item cursor_pointer', this.props?.permissions?.includes('deal_manage_deal_types') ? '' : 'disabled'].join(' ')}
                                                        title={!this.props?.permissions?.includes('deal_manage_deal_types') ? 'You do not have permission to perform this action' : ''}
                                                        style={{ "pointerEvents": "all" }}
                                                    >Edit</Link>
                                                </li>
                                                {this.props?.permissions?.includes('deal_manage_deal_types') && <li><Link className="dropdown-item" role="button"  onClick={() => this.changeStatus(term.id,term?.status?.status)}>Change Status</Link></li>}
                                                
                                            </ul>
                                        </td>
                                    </tr>)
                                })
                                : <tr><td className="text-center" colSpan="4">No Record</td></tr>)
                        }
                    </tbody>
                </table>
                {this.addTermsModalJsx()}
            </Ax>
        )
    }
}

const mapStateToProps = state => {
    return {
        access_token            :        state.auth.access_token,
        permissions             :       state.app.acl_info && state.app.acl_info.permissions && state.app.acl_info.permissions.length > 0 ? state.app.acl_info.permissions : []
    };
};

export default connect(mapStateToProps)(GeneralSettings);